/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../client/js/components/NoData'
import SelectionToggle from '../../../client/js/components/selection/SelectionToggle'
import UserListItem from './UserListItem'

export type UserListProps = {
  items: User[]
}

function UserList (props: UserListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th style={{ width: 50 }}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="username"
              defaultMessage="Nom d'utilisateur"
            />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="role"
              defaultMessage="Rôle"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 100 }}
          >
            <FormattedMessage
              id="status"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 200 }}
          >
            <FormattedMessage
              id="created_at"
              defaultMessage="Créé le"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <UserListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={5}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default UserList
